export default {
  actionList: 'list',
  actionNew: 'new',
  actionEdit: 'edit',
  actionDetail: 'detail',
  actionDelete: 'delete',
  actionCancel: 'cancel',
  success: 'Operação realizada com sucesso!'
}
